export default __webpack_public_path__ + "static/media/chrome_logo.ad9dab28.png";